import React, {Component} from 'react';
import {Input} from "reactstrap";
import './ReportDictation.scss';
import {promptAiText} from "../../../../shared/services/api-service";
import AiHelper from '../../../services/ai/survey-helper'

class ReportDictation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dictation: this.props.dictation,
      dictationEnabled: false,
      isListening: false,
      isProcessing: false,
      isLoading: false,
      dictationSupported: true,
      dictationMode: 'raw',
      errorMessage: '',
      errorDetails: '',
      showErrorDetails: false
    }
  }

  componentDidMount() {
    this.setupSpeechRecognition()
  }

  componentWillUnmount() {
    if (this.recognition) {
      this.recognition.stop(); // Stop this.recognition if the component is destroyed
      this.recognition.onstart = null;
      this.recognition.onresult = null;
      this.recognition.onerror = null;
      this.recognition.onend = null;
      this.recognition = null; // Clean up
      console.log('Speech recognition cleaned up');
    }
  }


  setupSpeechRecognition() {
    let speechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition

    if (!speechRecognition) {
      this.setState({dictationSupported: false})
      this.setError(
        'Dictation is not supported by this browser. You can still type or paste the report text.',
        'Neither window.SpeechRecognition nor window.webkitSpeechRecognition is available.'
      )
      return
    }

    this.recognition = new speechRecognition();
    this.recognition.continuous = true; // Keep listening even after a pause
    this.recognition.interimResults = true; // Get results while the user is still speaking
    this.recognition.lang = 'en-US'; // Set language

    this.recognition.onstart = () => {
      this.setState({
        isListening: true,
        isProcessing: true,
        errorMessage: '',
        errorDetails: '',
        showErrorDetails: false
      })
      console.log('Speech recognition started');
    };

    this.recognition.onresult = (event) => {
      let interimTranscript = '';
      let finalTranscript = '';

      // for (let i = event.resultIndex; i < event.results.length; ++i) {
      //   if (event.results[i].isFinal) {
      //     finalTranscript += event.results[i][0].transcript;
      //   } else {
      //     interimTranscript += event.results[i][0].transcript;
      //   }
      // }
      // Update transcript with the latest interim results, and append final results.
      // This provides a more responsive experience.
      // For a simpler version, you could just update on final results.
      // this.dictation =this.dictation.substring(0,this.dictation.length - interimTranscript.length) + finalTranscript + interimTranscript;

      let currentInterim = '';
      for (let i = 0; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript + ' ';
        } else {
          currentInterim += event.results[i][0].transcript;
        }
      }
      // Display interim results in a temporary way or update the main textarea
      // For this example, we'll append to keep it simple for demonstration.
      // A more sophisticated approach might replace the last part of the transcript.
      if (currentInterim) {
        // console.log('currentInterim', currentInterim)
        // This part can be tricky to manage perfectly with continuous text.
        // The provided solution above (first onresult block) is generally better for continuous dictation.
      }

      this.setState({
        dictation: this.initialDictation + finalTranscript
      })

      console.log('Result:', finalTranscript, interimTranscript);
    };

    this.recognition.onerror = (event) => {
      console.error('Speech recognition error', event.error);
      let error = event.error;
      if (event.error === 'no-speech') {
        error = 'No speech was detected. Please try again.';
      } else if (event.error === 'audio-capture') {
        error = 'No microphone was found. Ensure that a microphone is installed and permission is granted.';
      } else if (event.error === 'not-allowed') {
        error = 'Permission to use microphone was denied or is not granted. Please allow microphone access in your browser settings.';
      } else {
        error = `An error occurred: ${event.error}`;
      }
      this.setError(error, `Speech recognition error: ${event.error}`)
    };

    this.recognition.onend = () => {
      console.log('Speech recognition ended');
      // isProcessing could remain true if there's a slight delay server-side,
      // but for client-side only, we can set it to false.
      // If recognition stops unexpectedly, this ensures the button state is correct.
      // However, if continuous is true, onend might fire and then restart,
      // so we primarily rely on the button toggle.
      if (this.state.isProcessing && !this.state.errorMessage) { // if it ended without manual stop and no error, it might be processing the last bit
        // setTimeout(() => isProcessing.value = false, 1000); // Simulate processing delay
        this.setState({
          isProcessing: false
        })
      }

      this.setState({
        isListening: false,
      })
    };
  }

  toggleDictation()  {
    console.log('this.recognition', this.recognition)
    if (!this.recognition) return;

    if (this.state.isListening) {
      this.recognition.stop();
      // isProcessing will be set to false in onend or onerror
      console.log('Manually stopping recognition');
    } else {
      // this.dictation = ''; // Optionally clear transcript on new start
      this.initialDictation = this.state.dictation || ''
      this.setState({
        errorMessage: '',
        errorDetails: '',
        showErrorDetails: false
      })
      try {
        this.recognition.start();
      } catch (e) {
        // This can happen if recognition is already starting or in a bad state
        console.error("Error starting recognition:", e);
        this.setError('Could not start dictation. Please try again.', e.stack || e.message)
      }
    }
  }

  setError(errorMessage, errorDetails = '') {
    this.setState({
      errorMessage,
      errorDetails,
      showErrorDetails: false,
      isListening: false,
      isProcessing: false,
      isLoading: false
    })
  }

  getErrorDetails(error) {
    if (!error) return 'Unknown error'
    if (error.details) return error.details
    if (error.stack) return error.stack
    if (error.message) return error.message

    try {
      return JSON.stringify(error, null, 2)
    } catch (serializationError) {
      return String(error)
    }
  }

  fillTheReport() {
    /*
    Driving skills sub par, Field performance 4, officer is actively engaging in field activity, verbal control NRT, not observed physical contact
     */
    let normalizedReport = AiHelper.normalizeReportLayout(this.props.report)
    let systemPrompt = AiHelper.getFillFormPrompt(normalizedReport, this.state.dictationMode)
    this.setState({
      isLoading: true,
      errorMessage: '',
      errorDetails: '',
      showErrorDetails: false
    })
    console.log('systemPromt', systemPrompt)
    promptAiText({
      contents: this.state.dictation,
      systemInstructions: systemPrompt
    }).then((res) => {
      try {
        let rawResult = res && res.data && res.data.result
        if (typeof rawResult !== 'string') {
          let responseError = new Error('The AI service returned an incomplete response.')
          responseError.details = JSON.stringify(res, null, 2)
          throw responseError
        }

        let result = rawResult.replace(/^```json\s*/i, '').replace(/```\s*$/, '').trim()
        return JSON.parse(result)
      } catch (ex) {
        if (!ex.details) {
          let responseError = new Error('The AI response could not be applied to the report.')
          responseError.details = `${ex.message}\n\nRaw AI response:\n${res && res.data ? res.data.result : JSON.stringify(res, null, 2)}`
          return Promise.reject(responseError)
        }
        return Promise.reject(ex)
      }
    }).then(res => {
      this.props.onResponse( AiHelper.normalizeResponse(res, this.props.report))
      console.log('promptAiResult', res)
      this.setState({isLoading: false})
    }).catch((e) => {
        this.setError(
          e && e.message ? e.message : 'We could not process the dictation. Please try again.',
          this.getErrorDetails(e)
        )
      })
  }

  onChange({dictation}) {
    this.props.onChange(dictation)
    this.setState({dictation})
  }


  render() {
    return (
      <div className="report-dictation">
        <Input
          onChange={event => this.onChange({dictation: event.target.value})}
          value={this.state.dictation}
          type="textarea"
          placeholder="Start dictation to fill in the text or type the text"
        />
        <div className="dictation-mode-selector">
          <div className="dictation-mode-title">Comment style</div>
          {Object.keys(AiHelper.dictationModes).map(modeKey => {
            let mode = AiHelper.dictationModes[modeKey]
            return (
              <label className="dictation-mode-option" key={modeKey}>
                <input
                  type="radio"
                  name="dictation-mode"
                  value={modeKey}
                  checked={this.state.dictationMode === modeKey}
                  disabled={this.state.isLoading || this.state.isListening}
                  onChange={() => this.setState({dictationMode: modeKey})}
                />
                <span>
                  <strong>{mode.label}</strong>
                  <small>{mode.description}</small>
                </span>
              </label>
            )
          })}
        </div>
        {!this.state.isLoading && !this.state.isListening && <div className="report-dictation-actions">
          <button
            className="button primary small mr-1"
            disabled={!this.state.dictationSupported}
            onClick={() => this.toggleDictation()}>
            {this.state.dictationSupported ? 'Start dictation' : 'Dictation unavailable'}
          </button>
          <button className="button secondary small mr-1" onClick={() => this.fillTheReport()}>
            Fill the report
          </button>
          <button className="button danger small mr-1" onClick={() => this.props.onClose()}>
            Discard
          </button>
        </div>}
        {!this.state.isLoading && this.state.isListening && <div className="report-dictation-actions">
          <button className="button primary small mr-1" onClick={() => this.toggleDictation()}>
            Stop dictation
          </button>
          <span className="loader-dictation"></span>
        </div>}
        {this.state.isLoading && (
          <div className="dictation-loading">
            <span className="loader"></span>
          </div>
        )}
        {this.state.errorMessage && (
          <div className="dictation-error" role="alert">
            <div className="text-danger">{this.state.errorMessage}</div>
            {this.state.errorDetails && (
              <button
                type="button"
                className="button secondary small dictation-error-toggle"
                onClick={() => this.setState({showErrorDetails: !this.state.showErrorDetails})}>
                {this.state.showErrorDetails ? 'Hide technical details' : 'View technical details'}
              </button>
            )}
            {this.state.showErrorDetails && (
              <pre className="dictation-error-details">{this.state.errorDetails}</pre>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default ReportDictation;
